import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { Userprofile } from "src/app/_models/Userprofile";
import { AdministratorService } from "src/app/_services/administrator.service";
import { EditAdministrator } from "src/app/_models/Administrator";
import {
  GetAdminError,
  GetAdminSuccess,
  UpdateAdminSuccess,
  UpdateAdminError,
} from "./edit-administrator.actions";
import { UserProfileService } from "src/app/_services/userprofile.service";
import { EditAdministratorActionTypes } from "src/app/constants/StoreConstants";

@Injectable()
export class EditAdministratorEffects {
  constructor(
    private actions$: Actions,
    private userProfileService: UserProfileService,
    private administratorService: AdministratorService
  ) {}

  public getAdmin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EditAdministratorActionTypes.GetAdmin),
      switchMap((payload: { id: number }) => 
       this.userProfileService.getUserProfile$(payload.id).pipe(
          map((userProfile: Userprofile) => {
            return GetAdminSuccess({
              userProfile: userProfile,
              emailList: [],
            });
            }),
            catchError((error: any) => {
              return of(GetAdminError({ error: error }));
            })
        )
      )
    )
  );

  public updateAdmin$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EditAdministratorActionTypes.EditAdmin),
      switchMap((payload: { adminId: number; admin: EditAdministrator }) =>
        this.administratorService
          .updateAdministrator$(payload.adminId, payload.admin)
          .pipe(
            map((admin: Userprofile) => {
              admin.id = payload.adminId;
              return UpdateAdminSuccess({ updatedAdmin: admin });
            }),
            catchError((error: any) => {
              return of(UpdateAdminError({ error: error }));
            })
          )
      )
    );
  });
}
